module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }